<template>
	<div class="related-products-items" id="related-products">
		<div
			class="related-products-items-container"
			:style="`transform: translateX(${translateValue}px)`"
			@dragend="$emit('drag', $event)"
		>
			<related-products-item
				v-for="product in products"
				:key="product.id"
				:currency="currency"
				:product="product"
				@add-quantity="$emit('add-quantity', $event)"
				@change-value="$emit('change-value', $event)"
				@sub-quantity="$emit('sub-quantity', $event)"
			></related-products-item>
		</div>
	</div>
</template>

<script>
	import relatedProductsItem from '@/components/market-place/product-detail/related-products-item';

	export default {
		name: 'related-products-items',
		components: {
			relatedProductsItem,
		},
		props: {
			currency: String,
			products: {
				defautl: () => [],
				type: Array,
			},
			translateValue: [Number, String],
		},
	};
</script>

<style lang="scss" scoped>
	.related-products-items {
		cursor: pointer;
		height: 366px;
		overflow-x: hidden;
	}

	.related-products-items-container {
		display: flex;
		width: fit-content;
		transition: all 2s ease-in-out;
		width: -moz-fit-content;
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/product-detail/related-products-items.vue